module.exports = __webpack_public_path__ + "img/media2.53bd6ff1.png";